module.exports = __webpack_public_path__ + "img/mt_2.1b265381.png";